import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {reduxForm, getFormValues, getFormSyncWarnings} from 'redux-form';
import withStyles from '@mui/styles/withStyles';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {Typography} from '@mui/material';
import {HttpStatusCode} from 'axios';

import withRouter from '../../withRouter.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
import {sysErr} from '../../../../common/commonGmn.js';
import {postRequest} from '../../../../common/backend.js';

const styles = (theme) => ({
  modal: {
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'none',
  },
  paper: {
    backgroundColor: '#fafafa',
    border: '3px solid #fafafa',
    width: 'auto',
    height: 'auto',
    idth: '95%',
    overflow: 'auto',
    padding: '16pt',
    fontSize: '10pt',
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    margin: '15px 10px 5px 10px',
  },

});

// 承認状況
const approvalViews = [
  {binding: 'orderSequenceNumber', header: '順序番号', dataType: 'String', width: 90, isReadOnly: true},
  {binding: 'approvalRouteName', header: '承認ルート名', dataType: 'String', width: 120, isReadOnly: true},
  {binding: 'approvalStepName', header: '承認ステップ名', dataType: 'String', width: 135, isReadOnly: true},
  {binding: 'registerUserName', header: '申請者', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'registerDateTime', header: '申請日', dataType: 'String', width: 90, isReadOnly: true},
  {binding: 'stepApprovalName', header: '承認ステータス', dataType: 'String', width: 140, isReadOnly: true},
  {binding: 'approvalUserName', header: '承認者', dataType: 'String', width: 110, isReadOnly: true},
  {binding: 'stepApprovalDateTime', header: '承認日', dataType: 'String', width: 100, isReadOnly: true},
  {binding: 'stepApprovalComment', header: '承認コメント', dataType: 'String', width: 200, isReadOnly: true},
];

class ApprovalStatus extends React.Component {
  constructor(props) {
    super(props);

    this.gridRef1 = React.createRef();
    this.initializeData = [];
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      await this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期処理
   */
  async componentDidUpdate() {
    try {
      if (this.gridRef1.current && this.initializeData) {
        // 変更前リストデータを画面に設定
        this.gridRef1.current.setItemsSource(this.initializeData);
      }
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 承認状況描画
   * @return {*}
   */
  renderApprovalTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: false,
    };

    const component = createComponents(approvalViews);
    return (
      <CustomFlexGrid ref={this.gridRef1} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    const {appInfoNoList} = this.props;
    let _warningMessages = [];
    let approvalStep = [];
    this.initializeData =[];
    try {
      let _body = {
        searchConditionModel: {appInfoNoList: appInfoNoList},
      };
      // リクエスト出す
      let _url = 'scz1006/search-approval-step';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['承認状況', '検索']},
          });
        }
        return;
      }
      approvalStep = response.data.approvalStep || [];
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
    if (approvalStep) {
      this.initializeData = approvalStep;
      this.setState({
        modaltype: 'Approval',
      });
    }
  };

  render() {
    const {classes, openState, handleClose} = this.props;

    return (
      <Modal
        open={openState}
      >
        <PaperPart className={classes.paper}>
          <Typography variant='h6' sx={{fontWeight: 'bold'}}>承認状況</Typography>
          <div style={{marginTop: '15px'}} />
          {this.renderApprovalTable()}
          <div style={{marginBottom: '10px'}} />
          <Grid
            container
            justifyContent="center"
            alignItems="flex-end"
            spacing={1}
          >
            <Grid key="keyModalCloseBtn" item >
              <NegativeButton
                id="btnCloser"
                variant="contained"
                startIcon={<KeyboardReturnIcon />}
                size="middium"
                onClick={handleClose}
              >
                <span>閉じる</span>
              </NegativeButton>
            </Grid>
          </Grid>
        </PaperPart>
      </Modal>
    );
  }
}

ApprovalStatus.propTypes = {
  classes: PropTypes.object,
  handleClose: PropTypes.func,
  openState: PropTypes.bool,
  values: PropTypes.object,
  doShowMessage: PropTypes.func,
  appInfoNoList: PropTypes.object,
  userInfo: PropTypes.object,
};

const mapStateToProps = (state) => ({
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
};

const FORM_NAME = 'ApprovalStatus';

ApprovalStatus = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: false,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(ApprovalStatus));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(ApprovalStatus)),
);
